import React from 'react';
import {connect} from 'react-redux';
import {Route, Redirect, Switch} from 'react-router-dom';
import Navbar from './layout/Navbar';
import Error404 from './layout/Error404';
import Footer from './layout/Footer';
import Dashboard from './dashboard/Dashboard';
import PrintableDashboard from './dashboard/PrintableDashboard';
import SurveyList from './survey/SurveyList';
import SurveyEdit from './survey/SurveyEdit';
import SurveyCreate from './survey/SurveyCreate';
import SurveyExport from './survey/SurveyExport';
import SurveyShare from './survey/SurveyShare';
import SurveyTrackers from './survey/SurveyTrackers';
import Admin from './admin/Admin';
import UserCreate from './admin/UserCreate';
import UserEdit from './admin/UserEdit';
import Branding from './organization/Branding';
import Quicksight from './quicksightDashboards/Quicksight';
import MediaGalleryPage from './media/MediaGalleryPage';
import Downloader from './Downloader';

const Layout = ({user}) => (
    <>
        <Downloader />
        <Switch>
            <Route exact path="/dashboard/:id/print" component={PrintableDashboard} />
            <Route>
                <Navbar roles={user.roles} />
                <div className="container-fluid main-content">
                    <div className="row">
                        <main role="main" className="col-md-12 ml-sm-auto mt-3 px-4">
                            <Switch>
                                <Redirect path="/" exact to="/surveys" />
                                <Route exact path="/surveys" component={SurveyList} />
                                <Route exact path="/surveys/create" component={SurveyCreate} />
                                <Route exact path="/surveys/:id/edit" component={SurveyEdit} />
                                <Route exact path="/surveys/:id/export" component={SurveyExport} />
                                <Route exact path="/surveys/:id/share" component={SurveyShare} />
                                <Route path="/surveys/:id/trackers" component={SurveyTrackers} />
                                <Route exact path="/dashboard/:id" component={Dashboard} />
                                <Route exact path="/branding" component={Branding} />
                                <Route exact path="/media-library" component={MediaGalleryPage} />
                                <Route exact path="/admin/users" component={Admin} />
                                <Route exact path="/admin/users/create" component={UserCreate} />
                                <Route exact path="/admin/users/:id/edit" component={UserEdit} />
                                <Route exact path="/dashboards" component={Quicksight} />
                                <Route component={Error404} />
                            </Switch>
                        </main>
                    </div>
                </div>
                <Footer />
            </Route>
        </Switch>
    </>
);

const mapStateToProps = (state) => {
    return {
        user: state.auth.user,
    };
};

export default connect(mapStateToProps)(Layout);
